import * as yup from 'yup';

const resetPasswordSchema = yup.object().shape({
  newPassword: yup
    .string()
    .required('common.required')
    .matches(/^(?=.*\d)[a-zA-Z\d\w\W]{8,}$/, 'login.errors.passwordFormat'),

  confirmPassword: yup
    .string()
    .when('newPassword', {
      is: (val) => (!!(val && val.length > 0)),
      then: yup.string().required('common.required').oneOf(
        [yup.ref('newPassword')],
        'login.errors.identicalPasswords',
      ),
    }),
});

export default resetPasswordSchema;
